import { versionSelector } from '@/redux/store/slices/grid/gridSlice'
import { selectedReferenceFieldSelector } from '@/redux/store/slices/map/mapSlice'
import { useAppSelector } from '@redux/hooks/useAppState'
import { Layer, Source } from 'react-map-gl/mapbox'

import { getHoneygridFillPaintConfig, getHoneygridLinePaintConfig } from './functions'

import type { MaterializedGrid } from 'honeygrid-types'
import type { FC } from 'react'

interface HoneyGridOutlineLayerProps {
	beforeIdFill: { beforeId?: string }
	beforeIdLine: { beforeId?: string }
	honeygridData?: MaterializedGrid
}

export const HoneyGridOutlineLayer: FC<HoneyGridOutlineLayerProps> = ({
	beforeIdFill,
	beforeIdLine,
	honeygridData,
}) => {
	const selectedReferenceField = useAppSelector(selectedReferenceFieldSelector)
	const version = useAppSelector(versionSelector)

	const totalCells = honeygridData?.geojson?.features.length ?? 0
	const targetingFilter = version?.targeting_filters[selectedReferenceField]
	const builtInBoostSelectionIndex = Math.floor((targetingFilter?.percentage ?? 0) * totalCells)

	return (
		<>
			{honeygridData?.geojson?.features && honeygridData?.geojson?.features.length > 0 ? (
				<Source id="honeygrid" type="geojson" data={honeygridData?.geojson}>
					<Layer
						{...beforeIdFill}
						id="honeygrid-fill"
						type="fill"
						paint={getHoneygridFillPaintConfig(
							selectedReferenceField,
							honeygridData?.aggregatedDemographics
						)}
					/>
					<Layer
						{...beforeIdLine}
						id="honeygrid-line"
						type="line"
						paint={getHoneygridLinePaintConfig(selectedReferenceField, builtInBoostSelectionIndex)}
					/>
				</Source>
			) : null}
		</>
	)
}
